import React, { useState } from "react";
import '../css/components/Login.css'
import Logo from '../assets/logo3.png';
import ResponseMsg from '../general/ResponseMsg';
import { useNavigate } from "react-router-dom";
import '../css/components/UserLogin.css'
import DeliveryImg from '../assets/delivery-img.gif';

function DeliveryLogin() {

    const navigate = useNavigate();
    const [showReset, setShowReset] = useState(false);
    const [responseStatus, setResponseStatus] = useState();
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        phone: '',
        password: ''
    });

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [id]: value
        }));
    };

    const handleSignin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch('https://api.kcmstore.in/store/delivery-signin', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();
            setLoading(false);
            if (response.ok) {
                localStorage.setItem('userData', JSON.stringify(result));
                localStorage.setItem('isDeliveryAgent', 'true');
                setResponse('Login Successful.');
                setResponseStatus('success');
                setTimeout(() => {
                    setResponse('');
                    navigate('/delivery-dashboard');
                    window.location.reload();
                }, 2000);
            }
            else if (response.status == 400) {
                setResponse(result.message);
                setResponseStatus('error');

                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };


    const handleResetPassword = async (e) => {
        e.preventDefault();
        const { phone, password } = formData;

        try {
            const response = await fetch(`https://api.kcmstore.in/store/reset-delivery-password/${phone}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ password }),
            });

            const result = await response.json();
            if (response.ok) {
                setResponse(result.message);
                setTimeout(() => {
                    setResponse('');
                    setShowReset(false);
                }, 2000);
            } else {
                setResponse(result.message);
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        } catch (error) {
            console.log(error);
        }
    };


    return (
        <>
            <section>
                <div className="row">

                    <div className="col-lg-6 col-md-6 col-12 delivery-left">
                        <p className="delivery-heading">Welcome<br />Delivery Agent</p>
                        <img src={DeliveryImg} className="delivery-left-img" />
                    </div>


                    <div className='col-lg-4 col-md-5 mx-auto my-5 px-4 align-content-center text-center animate__animated animate__zoomIn'>
                        <div className="login-inner px-3 py-3">
                            <img src={Logo} className='cursor-pointer' style={{ height: '5em' }} onClick={() => navigate('/')} alt="Logo" />
                            <p className="tagline">KCM Online Store</p>

                            {response && (
                                <p className={`para-text fw-semibold my-3 rounded-2 ${responseStatus === 'success' ? 'text-success' : 'text-danger'}`}>
                                    {responseStatus === 'success' ? <i className="fa-solid fa-circle-check"></i> : <i className="fa-solid fa-circle-xmark"></i>} {response}
                                </p>
                            )}

                            {loading && (
                                <div>
                                    <i class="fa-solid fa-spinner text-dark animate__animated animate__rotateIn animate__infinite fs-5 mt-3"></i>
                                </div>
                            )}

                            <form className='my-3 text-start' onSubmit={handleSignin}>
                                <div className='mb-3'>
                                    <label htmlFor='phone' className='text-muted fw-semibold'>Mobile Number</label>
                                    <input
                                        type='tel'
                                        className='form-input'
                                        name='phone'
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        id='phone'
                                        maxLength='10'
                                        required
                                    />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='password' className='text-muted fw-semibold'>Password</label>
                                    <input
                                        type='password'
                                        className='form-input'
                                        name='password'
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        id='password'
                                        required
                                    />
                                </div>
                                <button type='submit' className='login-btn2 mt-3 w-100'>Sign In</button>
                            </form>
                            <p className='text-danger fw-bold cursor-pointer' onClick={() => setShowReset(true)}>Forgot Password?</p>
                        </div>
                    </div>


                </div>
            </section>


            {showReset && (
                <section className='delete-dialog px-3' onClick={() => setShowReset(false)}>
                    <div className='bg-white col-lg-4 col-md-5 col-10 mx-auto px-3 py-3 rounded-4 animate__animated animate__zoomIn' onClick={(e) => e.stopPropagation()}>

                        <p className='sec-heading fs-4'>Reset Password</p>


                        <form className="row g-3 mt-4" onSubmit={handleResetPassword}>
                            <div className="col-12 text-start">
                                <input
                                    type="tel"
                                    className="form-input"
                                    id="phone"
                                    name="phone"
                                    placeholder='Enter Mobile Number'
                                    maxLength='10'
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="col-12 text-start">
                                <input
                                    type="password"
                                    className="form-input"
                                    id="password"
                                    name="password"
                                    placeholder='Enter New Password'
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="col-12 my-4">
                                <button
                                    className="danger-btn"
                                    onClick={() => setShowReset(false)}
                                >
                                    Cancel
                                </button>
                                &nbsp;&nbsp;
                                <button type="submit" className="success-btn">
                                    Reset
                                </button>
                            </div>
                        </form>
                    </div>
                </section>
            )}


            {/* {response && <ResponseMsg message={response} />} */}

        </>
    );
}

export default DeliveryLogin;